import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveModulosAction } from '../ModulosAction';

const FormModulos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const modulosStore = Redux.useSelector((state) => state.modulos);

  const activo = modulosStore.activo;

  const initData = {
    nombre: '',
    alias: '',
    route: '',
    icon: '',
    desc: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    alias: false,
    route: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(() => setData({ ...values, idEstatus: activo.estatus.id }), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveModulosAction(
        { dispatch, notify },
        activo?.id,
        data,
        modulosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  React.useEffect(() => {
    const alias =
      data.nombre === '' ? '' : data.nombre.replaceAll(' ', '_').toLowerCase();
    setData({
      ...data,
      alias,
      route: data.nombre === '' ? '' : `/${alias}`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.nombre]);

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(CONST.nombre.name, e.target.value)
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.icon.name}
            label={CONST.icon.label}
            value={data.icon}
            onChange={(e) =>
              _handleSetDataField(CONST.icon.name, e.target.value)
            }
            helperText={dataError.icon ? validMessage.required : null}
            error={dataError.icon}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.alias.name}
            disabled
            label={CONST.alias.label}
            value={data.alias}
            onChange={(e) =>
              _handleSetDataField(CONST.alias.name, e.target.value)
            }
            helperText={dataError.alias ? validMessage.required : null}
            error={dataError.alias}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.route.name}
            required
            disabled
            label={CONST.route.label}
            value={data.route}
            onChange={(e) =>
              _handleSetDataField(CONST.route.name, e.target.value)
            }
            helperText={dataError.route ? validMessage.required : null}
            error={dataError.route}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <EstatusField
            value={data.idEstatus}
            isEstatus
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormModulos;
